import { render, staticRenderFns } from "./VMapBox.vue?vue&type=template&id=77cd2756"
import script from "./VMapBox.vue?vue&type=script&lang=js"
export * from "./VMapBox.vue?vue&type=script&lang=js"
import style0 from "./VMapBox.vue?vue&type=style&index=0&id=77cd2756&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports